export default {
	lang: 'th',
	nav: {
		"nav_lang_zh": '中文（简体）',
		"nav_lang_en": 'English',
		"nav_lang_tw": '中文（繁體）',
		"nav_lang_ja": '日本語',
		"nav_lang_ko": '한국어',
		"nav_lang_de": 'Deutsch',
		"nav_lang_fr": 'Français',
		"nav_lang_th": 'ภาษาไทย',
		"nav_lang_it": 'Italiano',
		"nav_lang_es": 'Español',
		"nav_lang_ru": 'Русский',
		"nav0": 'ความปลอดภัยของบัญชี',
		"nav1": 'ดิสก์บนคลาวด์ของฉัน',
		"nav2": 'ออกจากระบบ',
		"nav3": 'เข้าสู่ระบบ/ลงทะเบียน',
		"nav4": 'สามารถบันทึกการโทรและเนื้อหาเสียงบนโทรศัพท์และแปลงเป็นข้อความได้ ต้องเชื่อมต่อหูฟังซีรีส์ VTransBUDS จึงจะใช้งานได้',
		"nav5": 'สแกนรหัสเพื่อดาวน์โหลด',
		"nav6": 'การสื่อสารที่สำคัญ การย้อนกลับที่มีประสิทธิภาพ',
		"speaker_not_null": 'ไม่สามารถแก้ไขลำโพงว่างเปล่าได้!',
		"speaker": 'ลำโพง',
		"copy_success": 'คัดลอกสำเร็จ',
	},
	login: {
		"login1": 'รหัสผ่านเข้าสู่ระบบ',
		"login2": 'รหัสผ่านเข้าสู่ระบบ',
		"loginTab3": 'รหัสผ่านเข้าสู่ระบบ',
		"login3": 'อีเมล',
		"login4": 'รหัสผ่านเข้าสู่ระบบ',
		"login5": 'หมายเลขโทรศัพท์มือถือ',
		"login6": 'กรุณาเลือก',
		"login7": 'รหัสยืนยันโทรศัพท์มือถือ',
		"login8": 'เข้าสู่ระบบ',
		"login9": 'ลืมรหัสผ่าน',
		"login10": 'ลงทะเบียน',
		"login11": 'การเข้าสู่ระบบหมายความว่าคุณยอมรับ',
		"login12": 'ข้อตกลงบริการ',
		"login13": 'ข้อตกลงความเป็นส่วนตัว',
		"login14": 'รับ',
		"login15": 'จีน',
		"login16": 'กรุณาป้อนรหัสของคุณ บัญชี',
		"login17": 'กรุณาป้อนรหัสผ่านของคุณ',
		"login18": 'เข้าสู่ระบบสำเร็จ!',
		"login19": 'กรุณาป้อนรหัสยืนยัน!',
		"login20": 'ส่งเรียบร้อยแล้ว!',
		"login21": 'และ',
		"login22": 'คลาวด์ดิสก์เครื่องบันทึก',
		"login23": 'การเขียนของฉัน',
		"login24": 'การสนทนาของฉัน',
		"login25": 'ความปลอดภัยของบัญชี',
		"login26": 'ออกจากระบบ',
		"login27": 'การเรียกค้นรหัสผ่านอีเมล',
		"login28": 'อีเมล',
		"login29": 'รหัสยืนยันอีเมล',
		"login30": 'ตั้งรหัสผ่านการเข้าสู่ระบบ (6-16 ตัวอักษร)',
		"login31": 'ป้อนรหัสผ่านการเข้าสู่ระบบ อีกครั้ง',
		"login32": 'ส่ง',
		"login33": 'กลับสู่การเข้าสู่ระบบ',
		"login34": 'เปลี่ยนแปลงเรียบร้อยแล้ว!',
	},
	register: {
		"register1": 'หมายเลขโทรศัพท์มือถือ',
		"register2": 'กรุณากรอกหมายเลขโทรศัพท์มือถือของคุณ',
		"register3": 'กรุณาเลือก',
		"register4": 'รหัสยืนยันโทรศัพท์มือถือ',
		"register5": 'ตั้งรหัสผ่าน',
		"register6": 'กรุณากรอกรหัสยืนยัน',
		"register7": '6-16 ตัวอักษร',
		"register8": 'ยืนยันรหัสผ่าน',
		"register9": 'อีเมล',
		"register10": 'กรุณากรอกอีเมล',
		"register11": 'รหัสยืนยันอีเมล',
		"register12": 'กรุณากรอกรหัสยืนยัน',
		"register13": 'ฉันได้อ่านและตกลงแล้ว',
		"register14": 'กรุณาอ่านและตรวจสอบข้อตกลง',
		"register15": 'รูปแบบหมายเลขโทรศัพท์มือถือไม่ถูกต้อง / หมายเลขโทรศัพท์มือถือได้รับการลงทะเบียนแล้ว',
		"register16": 'รหัสยืนยันโทรศัพท์มือถือไม่ถูกต้อง',
		"register17": 'กรุณากรอกอีเมล / ข้อผิดพลาดรูปแบบอีเมล',
		"register18": 'ข้อผิดพลาดรูปแบบอีเมล',
		"register19": 'ข้อผิดพลาดรหัสยืนยันอีเมล',
		"register20": 'กรุณาตั้งรหัสผ่านเป็น 6-16 ตัวอักษร',
		"register21": 'ข้อผิดพลาดรูปแบบรหัสผ่าน',
		"register22": 'รหัสผ่านทั้งสองไม่สอดคล้องกัน กรุณากรอกใหม่อีกครั้ง',
		"register23": 'กรุณากรอกรหัสผ่าน',
		"register24": 'ลงทะเบียนสำเร็จ!',
		"register25": 'ข้อผิดพลาดรหัสยืนยัน',
	},
	recorder: {
		"recorder1": 'ดิสก์คลาวด์ของฉัน',
		"recorder2": 'ความจุพื้นที่คลาวด์',
		"recorder3": 'ไฟล์ล่าสุด',
		"recorder331": 'ถังขยะรีไซเคิล',
		"recorder332": 'ลบทั้งหมด',
		"recorder4": 'ชื่อ',
		"recorder5": 'ระยะเวลาเสียง',
		"recorder6": 'ขนาดไฟล์',
		"recorder7": 'เวลาสร้าง',
		"recorder8": 'การทำงาน',
		"recorder9": 'คำอธิบายพื้นที่คลาวด์',
		"recorder10": 'เสียง',
		"recorder11": 'ไฟล์ OCR',
		"recorder12": '1. พื้นที่คลาวด์ใช้ทำอะไร',
		"recorder13": 'หลังจากบันทึกบนเครื่องบันทึกแล้ว คุณสามารถอัปโหลดไฟล์เสียงและไฟล์ที่ถอดเสียงไปยังพื้นที่คลาวด์ได้ แม้ว่าเครื่องบันทึกจะไม่อยู่กับคุณ แต่คุณสามารถเข้าสู่พื้นที่คลาวด์เพื่อดูเสียงได้ ',
		"recorder14": '2. จะอัปโหลดไปยังพื้นที่คลาวด์ได้อย่างไร?',
		"recorder15": 'เข้าสู่ [ไฟล์ของฉัน] บนเครื่องบันทึก เลือกไฟล์เป้าหมายและกดค้างไว้เพื่อแสดงตัวเลือก คลิก "อัปโหลด" เพื่ออัปโหลดไฟล์ไปยังพื้นที่คลาวด์ ',
		"recorder16": '3. จะดู/จัดการไฟล์พื้นที่คลาวด์ได้อย่างไร?',
		"recorder17": 'เข้าสู่ระบบเว็บไซต์อย่างเป็นทางการของ Beibo เลือก "My-Recorder Cloud Disk" แล้วคุณจะสามารถดูไฟล์เครื่องบันทึกที่อัปโหลดได้ คุณสามารถเลือกไฟล์เป้าหมายเพื่อดาวน์โหลด ลบ และดำเนินการอื่นๆ คุณสามารถล้างที่เก็บข้อมูลบนคลาวด์ได้โดยการลบไฟล์บนคลาวด์!',
		"recorder18": 'ไม่ได้ถอดเสียง',
		"recorder19": 'ดูสรุป',
		"recorder20": 'ผู้พูด',
		"recorder21": 'แก้ไขชื่อผู้พูด',
		"recorder22": 'ยืนยัน',
		"recorder23": 'ดาวน์โหลด',
		"recorder24": 'ดาวน์โหลดเนื้อหา:',
		"recorder25": 'การตั้งค่าการดาวน์โหลด:',
		"recorder26": 'แสดงผู้พูด',
		"recorder27": 'ยกเลิก',
		"recorder28": 'การแชร์ลิงก์',
		"recorder29": 'ใครก็ตามที่ได้รับลิงก์สามารถเข้าถึงได้ รองรับการอ่านเท่านั้น ลิงก์นี้ใช้ได้ 7 วัน',
		"recorder30": 'คัดลอกลิงก์',
		"recorder31": 'สแกนและดูอย่างรวดเร็ว',
		"recorder32": 'การจัดระเบียบอย่างชาญฉลาด',
		"recorder33": 'แยกแยะผู้พูด',
		"recorder34": 'แยกแยะข้อความที่ถอดเสียงอย่างชาญฉลาดตามบทบาทของผู้พูด',
		"recorder35": 'การปรับภาษาพูดอย่างชาญฉลาด',
		"recorder36": 'กรองอนุภาคโหมด คำที่ซ้ำ และหยุดคำโดยอัตโนมัติ',
		"recorder37": 'การกรองเสียงที่ไม่ใช่ของมนุษย์',
		"recorder38": 'ข้ามเสียงโดยอัตโนมัติโดยไม่มีเสียงของมนุษย์และเสียงรบกวนระหว่างการเล่น',
		"recorder39": 'กรุณาเลือก',
		"recorder40": 'เอกสาร',
		"recorder41": 'เสียง',
		"recorder42": 'เอกสาร+เสียง',
		"recorder43":'พร้อมท์',
		"recorder44":'การดำเนินการนี้จะลบไฟล์ คุณต้องการดำเนินการต่อหรือไม่?',
		"recorder441":'การดำเนินการนี้จะลบไฟล์ทั้งหมด คุณต้องการดำเนินการต่อหรือไม่?',
		"recorder45":'ตกลง',
		"recorder46":'ยกเลิก',
		"recorder47":'ลบสำเร็จแล้ว!',
		"recorder48":'ลบแล้ว ยกเลิก',
		"recorder49":'ยังไม่มีเครื่องหมาย',
		"recorder50":"กำลังบันทึก...",
		"recorder51":'ถังขยะรีไซเคิล',
	},
	personal: {
		"personal1": 'การตั้งค่าบัญชี',
		"personal2": 'ข้อมูลส่วนตัว',
		"personal3": 'อวาตาร์',
		"personal4": 'อัปโหลดไฟล์',
		"personal5": 'รองรับรูปแบบ JPG, JPEG, GIF, PNG รองรับรูปภาพขนาดไม่เกิน 2 ล้านรูป',
		"personal6": 'ชื่อเล่น',
		"personal7": 'กรุณากรอกชื่อเล่น',
		"personal8": 'เพศ',
		"personal9": 'นาย',
		"personal10": 'นางสาว',
		"personal11": 'ข้อมูลลับ',
		"personal12": 'วันเกิด',
		"personal13": 'กรุณาเลือกวันเกิดของคุณ',
		"personal14": 'อาชีพ',
		"personal15": 'กรุณาเลือกอาชีพของคุณ',
		"personal16": 'กรุณาระบุอาชีพของคุณ (ไม่บังคับ)',
		"personal17": 'ประเทศ',
		"personal18": 'กรุณาเลือกประเทศของคุณ',
		"personal19": 'บันทึก',
		"personal20": 'ข้อมูลส่วนตัว',
		"personal21": 'ความปลอดภัยของบัญชี',
		"personal22": 'รองรับเฉพาะรูปภาพที่มีขนาดไม่เกิน 2 ล้านรูป',
		"personal23": 'อัปโหลดสำเร็จ!',
		"personal24": 'เปลี่ยนแปลงสำเร็จ!',
		"personal25": 'ความปลอดภัยของบัญชี',
		"personal26": 'รหัสผ่านในการเข้าสู่ระบบ',
		"personal27": 'เปลี่ยนแปลง',
		"personal28": 'อีเมล',
		"personal29": 'เปลี่ยนแปลง',
		"personal30": 'ยกเลิกบัญชี',
		"personal32": 'คุณแน่ใจหรือไม่ว่าต้องการยกเลิกบัญชีของคุณ บัญชี?',
		"personal33": 'หลังจากยกเลิกแล้ว เนื้อหาทั้งหมดในบัญชีของคุณจะถูกล้าง โปรดดำเนินการด้วยความระมัดระวัง ',
		"personal34": 'ยกเลิก',
		"personal35": 'ยืนยัน',
		"personal36": 'การยืนยันตัวตน',
		"personal37": 'เพื่อยืนยันว่าคุณเป็นผู้ดำเนินการ โปรดดำเนินการยืนยันตัวตนผ่านรหัสยืนยันอีเมล',
		"personal38": 'อีเมล',
		"personal39": 'รหัสยืนยัน',
		"personal40": 'กรุณาป้อนรหัสยืนยัน',
		"personal41": 'ถัดไป',
		"personal42": 'ตั้งค่าอีเมลใหม่',
		"personal43": 'อีเมล',
		"personal44": 'กรุณาป้อนอีเมลใหม่',
		"personal45": 'รหัสยืนยัน',
		"personal46": 'กรุณาป้อนรหัสยืนยัน',
		"personal47": 'ยืนยัน',
		"personal48": 'ตั้งรหัสผ่านเข้าสู่ระบบใหม่',
		"personal49": 'รหัสผ่านเข้าสู่ระบบใหม่',
		"personal50": 'กรุณาป้อนรหัสผ่านใหม่',
		"personal51": 'ยืนยันรหัสผ่านใหม่',
		"personal52": 'กรุณาป้อนรหัสผ่านใหม่อีกครั้ง',
		"personal53": 'ยืนยัน',
		"personal54": 'รับ',
		"personal55": 'ข้อผิดพลาดรูปแบบอีเมล',
		"personal56": 'เปลี่ยนเรียบร้อยแล้ว!',
		"personal57": 'กรุณาตั้งรหัสผ่านเป็น 6-16 ตัวอักษร',
		"personal58": 'รหัสผ่านที่ป้อนสองรหัสไม่สอดคล้องกัน',
		"personal59": 'เปลี่ยนเรียบร้อยแล้ว!',
		"personal60": 'ออกจากระบบเรียบร้อยแล้ว!',
		"share_url": "การแชร์ลิงก์",
		"share_url_7_day": "ลิงก์สำหรับแชร์มีอายุการใช้งาน 7 วัน ใครก็ตามที่ได้รับลิงก์จะสามารถเข้าถึงได้ก่อนหมดอายุ",
		"share_audio": "การบันทึกเสียง",
		"share_trans_text": "การถอดเสียง",
		"share_summny_text": "สรุป",
		"share_map": "แผนผังความคิด",
		"share_url_pw": "การเข้ารหัสการเข้าถึง",
		"share_random_pw": "รหัสผ่านที่สร้างขึ้นแบบสุ่ม",
		"share_url_copy": "คัดลอกลิงก์",
		"share_link_pw": "รหัสผ่านการเข้าถึง",
		"share_copy_success": "คัดลอกสำเร็จ!",
		"share_speaker": "ผู้พูด",
		"share_no_update_speaker": "ไม่สามารถแก้ไขผู้พูดได้ ลำโพงว่างเปล่า",
		"share_no_trans":"ไม่ การถอดเสียง",
		"share_no_summny":"ไม่มีสรุป",
		"share_no_map":"ไม่มีเนื้อหาแผนที่",
		"share_trans_text_1": "การถอดเสียง",
		"share_summny_text_1": "สรุป",
		"share_map_1": "แผนที่",
		"share_save": "บันทึกสำเร็จ",
		"share_no_map":"ไม่ได้สร้างภาพแผนที่",
		"share_update_text": "แก้ไขข้อความถอดเสียง",
		"share_update_text2": "แก้ไขข้อความสรุป",
		"showLoading": "กำลังโหลด...",
	}
}